var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartlyCloudyWintryMix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.955,
    height: 56.684,
    viewBox: "0 0 46.955 56.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Partly_Cloudy_-_Wintry_Mix",
    "data-name": "Partly Cloudy - Wintry Mix",
    transform: "translate(-1393.188 -302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167390",
    "data-name": "Path 167390",
    d: "M30.309,40.066H9.449a10.32,10.32,0,0,1-6.555-2.039A8.051,8.051,0,0,1,0,31.493a7.906,7.906,0,0,1,2.6-6.026,10.3,10.3,0,0,1,5.259-2.417c.005,0,.008,0,.008-.005a14.547,14.547,0,0,1,4.484-8.617,12.43,12.43,0,0,1,8.334-3.179A11.785,11.785,0,0,1,27.966,13.7a12.788,12.788,0,0,1,3.76,4.791,1.429,1.429,0,0,0,1,.811,11.56,11.56,0,0,1,5.809,3.062,9.966,9.966,0,0,1,2.83,7.187,10.183,10.183,0,0,1-3.3,7.611A11.388,11.388,0,0,1,30.309,40.066ZM32,19.158Z",
    transform: "translate(1394.457 302.137)",
    fill: "#b1b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167391",
    "data-name": "Path 167391",
    d: "M29.413,17.752a15.2,15.2,0,0,1,3.13,1.324.36.36,0,0,0,.524-.22,8.657,8.657,0,0,0-8.32-10.982,8.6,8.6,0,0,0-4.96,1.562h-.005a.3.3,0,0,0,.09.54,14.628,14.628,0,0,1,4.618,2.377,15.662,15.662,0,0,1,4.082,4.728A1.441,1.441,0,0,0,29.413,17.752Z",
    transform: "translate(1399.648 301.295)",
    fill: "#f6be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167392",
    "data-name": "Path 167392",
    d: "M35.822,16.382H32.941a1.441,1.441,0,1,1,0-2.882h2.882a1.441,1.441,0,1,1,0,2.882Z",
    transform: "translate(1402.879 302.855)",
    fill: "#f6be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167393",
    "data-name": "Path 167393",
    d: "M23.941,8.013A1.441,1.441,0,0,1,22.5,6.572V3.691a1.441,1.441,0,1,1,2.882,0V6.572A1.441,1.441,0,0,1,23.941,8.013Z",
    transform: "translate(1400.492 299.75)",
    fill: "#f6be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167394",
    "data-name": "Path 167394",
    d: "M18.023,10.464a1.433,1.433,0,0,1-1.018-.423L14.968,8.005a1.441,1.441,0,0,1,2.038-2.038l2.036,2.038a1.441,1.441,0,0,1-1.018,2.459Z",
    transform: "translate(1398.35 300.676)",
    fill: "#f6be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167395",
    "data-name": "Path 167395",
    d: "M30.3,10.464a1.441,1.441,0,0,1-1.018-2.459l2.036-2.038A1.441,1.441,0,1,1,33.36,8.005l-2.038,2.036a1.433,1.433,0,0,1-1.018.423Z",
    transform: "translate(1402.141 300.676)",
    fill: "#f6be00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wintry_Mix",
    "data-name": "Wintry Mix",
    transform: "translate(670.813 -223.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "snow",
    d: "M11.229,7.782l-.68-.393a1.79,1.79,0,0,1,.419-.32.44.44,0,1,0-.425-.77,2.671,2.671,0,0,0-.771.642L8.01,5.923,9.771,4.906a2.668,2.668,0,0,0,.771.642.44.44,0,1,0,.425-.77,1.794,1.794,0,0,1-.419-.32l.68-.393a.44.44,0,1,0-.44-.761l-.68.392a1.794,1.794,0,0,1-.068-.523.44.44,0,0,0-.431-.449H9.6a.44.44,0,0,0-.44.432,2.671,2.671,0,0,0,.17.988L7.57,5.161V3.128a2.669,2.669,0,0,0,.941-.347.44.44,0,0,0-.454-.753,1.79,1.79,0,0,1-.487.2V1.565a.44.44,0,1,0-.88,0V2.23a1.79,1.79,0,0,1-.487-.2.44.44,0,0,0-.454.753,2.669,2.669,0,0,0,.941.347V5.161L4.929,4.144a2.671,2.671,0,0,0,.17-.988.44.44,0,0,0-.44-.432H4.651a.44.44,0,0,0-.432.448,1.794,1.794,0,0,1-.068.523L3.472,3.3a.44.44,0,1,0-.44.762l.68.393a1.794,1.794,0,0,1-.419.32.44.44,0,1,0,.425.77,2.671,2.671,0,0,0,.771-.642L6.251,5.923,4.49,6.94A2.671,2.671,0,0,0,3.719,6.3a.44.44,0,1,0-.425.77,1.794,1.794,0,0,1,.419.32l-.68.394a.44.44,0,1,0,.44.762l.68-.392a1.794,1.794,0,0,1,.068.523.44.44,0,0,0,.431.447H4.66A.44.44,0,0,0,5.1,8.69a2.671,2.671,0,0,0-.17-.988L6.691,6.685V8.718a2.669,2.669,0,0,0-.941.347.44.44,0,0,0,.454.753,1.79,1.79,0,0,1,.487-.2v.665a.44.44,0,1,0,.88,0V9.616a1.79,1.79,0,0,1,.487.2.44.44,0,0,0,.454-.753,2.669,2.669,0,0,0-.941-.347V6.685L9.331,7.7a2.671,2.671,0,0,0-.17.988.44.44,0,0,0,.44.432h.009a.44.44,0,0,0,.432-.448,1.794,1.794,0,0,1,.068-.523l.68.392a.44.44,0,1,0,.44-.761Z",
    transform: "translate(741.719 568.922)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "snow-2",
    "data-name": "snow",
    d: "M11.229,7.782l-.68-.393a1.79,1.79,0,0,1,.419-.32.44.44,0,1,0-.425-.77,2.671,2.671,0,0,0-.771.642L8.01,5.923,9.771,4.906a2.668,2.668,0,0,0,.771.642.44.44,0,1,0,.425-.77,1.794,1.794,0,0,1-.419-.32l.68-.393a.44.44,0,1,0-.44-.761l-.68.392a1.794,1.794,0,0,1-.068-.523.44.44,0,0,0-.431-.449H9.6a.44.44,0,0,0-.44.432,2.671,2.671,0,0,0,.17.988L7.57,5.161V3.128a2.669,2.669,0,0,0,.941-.347.44.44,0,0,0-.454-.753,1.79,1.79,0,0,1-.487.2V1.565a.44.44,0,1,0-.88,0V2.23a1.79,1.79,0,0,1-.487-.2.44.44,0,0,0-.454.753,2.669,2.669,0,0,0,.941.347V5.161L4.929,4.144a2.671,2.671,0,0,0,.17-.988.44.44,0,0,0-.44-.432H4.651a.44.44,0,0,0-.432.448,1.794,1.794,0,0,1-.068.523L3.472,3.3a.44.44,0,1,0-.44.762l.68.393a1.794,1.794,0,0,1-.419.32.44.44,0,1,0,.425.77,2.671,2.671,0,0,0,.771-.642L6.251,5.923,4.49,6.94A2.671,2.671,0,0,0,3.719,6.3a.44.44,0,1,0-.425.77,1.794,1.794,0,0,1,.419.32l-.68.394a.44.44,0,1,0,.44.762l.68-.392a1.794,1.794,0,0,1,.068.523.44.44,0,0,0,.431.447H4.66A.44.44,0,0,0,5.1,8.69a2.671,2.671,0,0,0-.17-.988L6.691,6.685V8.718a2.669,2.669,0,0,0-.941.347.44.44,0,0,0,.454.753,1.79,1.79,0,0,1,.487-.2v.665a.44.44,0,1,0,.88,0V9.616a1.79,1.79,0,0,1,.487.2.44.44,0,0,0,.454-.753,2.669,2.669,0,0,0-.941-.347V6.685L9.331,7.7a2.671,2.671,0,0,0-.17.988.44.44,0,0,0,.44.432h.009a.44.44,0,0,0,.432-.448,1.794,1.794,0,0,1,.068-.523l.68.392a.44.44,0,1,0,.44-.761Z",
    transform: "translate(752.719 567.762)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167436",
    "data-name": "Path 167436",
    d: "M11.835,39.564a1.711,1.711,0,0,1-1.421-2.66l6.845-10.267a1.712,1.712,0,1,1,2.847,1.9L13.262,38.8A1.711,1.711,0,0,1,11.835,39.564Z",
    transform: "translate(712.248 542.125)",
    fill: "#00a9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167437",
    "data-name": "Path 167437",
    d: "M19.711,34.431a1.711,1.711,0,0,1-1.422-2.66l3.422-5.134a1.712,1.712,0,0,1,2.847,1.9L21.136,33.67A1.711,1.711,0,0,1,19.711,34.431Z",
    transform: "translate(716.34 542.125)",
    fill: "#00a9e0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloudyWintryMix);
export default __webpack_public_path__ + "static/media/partly-cloudy-wintry-mix.898d4a05b266ad803839a9897fd1fcbb.svg";
export { ForwardRef as ReactComponent };